import { useAsyncData } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { getOptionalEndpointTimeoutOptions } from '~/scopes/product/utils/optionalEndpointTimeout'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useFetchBreadcrumb() {
  const { productId } = useUrlParams()
  const $httpFetch = useHttpFetch()

  return useAsyncData(
    `pp-breadcrumb-${productId}`,
    async () =>
      await $httpFetch('/bm/landing_page/product/:productId/breadcrumb', {
        pathParams: { productId },
      }),
    {
      ...getOptionalEndpointTimeoutOptions(),
      dedupe: 'defer',
    },
  )
}
